import React from "react";

import Input from "../forms/Input";
import ColorCheckbox from "../forms/ColorCheckbox";
import BaseModal from "../modals/BaseModal";

export default class CanvasserLegend extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      //canvasser filters
      showAssignedCanvassers: true,
      availableCanvasserStatuses: [
        "checked_in",
        "not_checked_in",
        "unscheduled",
      ],
      displayedCanvasserStatuses: [
        "checked_in",
        "not_checked_in",
        "unscheduled",
      ],
    };

    this.colorClassMapping = {
      checked_in: { class: "_green", color: "#33a02c" },
      not_checked_in: { class: "_red", color: "#e31a1c" },
      unscheduled: { class: "_grey", color: "darkgrey" },
      assigned: { class: "_blue", color: "#1f78b4" },
    };
  }

  _handleLegendCheckboxToggle = (status) => {
    //check if status is in display
    let new_displayed_statuses;
    if (this.state.displayedCanvasserStatuses.includes(status)) {
      new_displayed_statuses = this.state.displayedCanvasserStatuses.filter(
        (d) => d !== status
      );
    } else {
      new_displayed_statuses = [
        ...this.state.displayedCanvasserStatuses,
        status,
      ];
    }

    this.setState({ displayedCanvasserStatuses: new_displayed_statuses });
  };

  render() {
    return (
      <BaseModal
        open={this.props.open}
        onClose={this.props.onClose}
        title="Filter Canvassers"
        onClick={() =>
          this.props.handleFilterUpdate(
            this.state.displayedCanvasserStatuses,
            this.state.showAssignedCanvassers
          )
        }
        center
      >
        <div className={"wrapper"} style={{ margin: "2em" }}>
          <Input
            type={"checkbox"}
            key={Math.random()}
            value={this.state.showAssignedCanvassers}
            defaultChecked={this.state.showAssignedCanvassers}
            onChange={() =>
              this.setState({
                showAssignedCanvassers: !this.state.showAssignedCanvassers,
              })
            }
            title={"Show Assigned"}
            style={{ marginBottom: "1px" }}
          />

          {this.state.availableCanvasserStatuses.map((d) => {
            return (
              <ColorCheckbox
                className={this.colorClassMapping[d].class}
                handleChange={() => this._handleLegendCheckboxToggle(d)}
                value={this.state.displayedCanvasserStatuses.includes(d)}
                title={
                  d.charAt(0).toUpperCase() + d.slice(1).replace(/_/g, " ")
                }
                key={d}
                style={{ transform: "scale(.85)" }}
              />
            );
          })}
          <div className="button-wrapper">
            <button
              className="button"
              type={"submit"}
              onClick={() =>
                this.props.handleFilterUpdate(
                  this.state.displayedCanvasserStatuses,
                  this.state.showAssignedCanvassers
                )
              }
            >
              OK
            </button>
            <div
              className="button button-outline"
              onClick={() =>
                this.setState({
                  displayedCanvasserStatuses:
                    this.state.availableCanvasserStatuses,
                  showAssignedCanvassers: true,
                })
              }
            >
              Clear Filters
            </div>
          </div>
        </div>
      </BaseModal>
    );
  }
}
